import { useGetDashboardQuery } from '../dashboardApi';
import { useDashboardFilters } from './useDashboardFilters';
import { useIsLoggedIn, useIsIncarnated, useAuthLoading } from '../../auth/hooks';

export const useDashboard = (queryParams = {}, options = {}) => {
  const isLoggedIn = useIsLoggedIn();
  const { isAuthLoading } = useAuthLoading();
  const isIncarnated = useIsIncarnated();

  const defaultQueryParams = {
    sortBy: 'lastVisit',
    filters: [],
    ...queryParams
  };

  const defaultOptions = {
    skip: !isLoggedIn || isAuthLoading,
    ...options
  };

  const { data: dashboardData, isLoading, isFetching, isError, isUninitialized, refetch, error } = useGetDashboardQuery(
    defaultQueryParams,
    defaultOptions
  );

  const courses = dashboardData ?? [];
  const { currentFilter, filterOptions: filterDefs } = useDashboardFilters();
  const status = isLoading || isFetching ? 'loading' : isError ? 'error' : 'idle';

  // Apply filter to current courses (mirrors selectors.js behavior)
  const filteredCourses = courses?.filter(filterDefs[currentFilter]?.fnc || filterDefs[0].fnc) ?? [];

  return {
    courses,
    filteredCourses,
    dashboardData,
    isLoading,
    status,
    currentFilter,
    refetch,
    error,
    isIncarnated,
    isUninitialized,
  };
};

